import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween, FlexCenter } from '../../../global/commonStyle';

const Bottom = styled.div`
  padding: var(--space-8);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;
const Option = styled.div`
  padding: var(--space-8);
  ${FlexBetween}
  gap: var(--space-10);
`;
const Options = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
`;
const LeftOptionDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;

const Icon = styled.div`
  ${FlexCenter}
`;
const Name = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;

const FirstOption = styled.div`
  padding: var(--space-8);
  &.active {
    border-radius: var(--border-radius-8);
    display: flex;
    flex-direction: column;
    border: 0.5px solid var(--border-primary);
    background-color: var(--background-tertiary);
    gap: var(--space-16);
    .btn {
      width: 100%;
    }
  }
`;
const ExpiryOption = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  &.public-duplication {
    display: none;
  }
`;

export { Bottom, Option, LeftOptionDiv, Icon, Name, FirstOption, ExpiryOption, Options };
